import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { FormField } from '../../../../models/built-form';

// TODO: implement config UI
@Component({
  selector: 'app-live-geo-coordinates-config-view',
  standalone: true,
  templateUrl: './live-geo-coordinates-config-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveGeoCoordinatesConfigViewComponent {
  readonly field = input.required<FormField>();
  readonly fieldChange = output<FormField>();
}
